interface OverlayDevmodeProps {
  handleClick?: () => void
}

export const CompOverlayDevmode: React.FC<OverlayDevmodeProps> = ({ handleClick }) => {
  return (
    <div
      className='absolute top-0 left-0 right-0 bottom-0 bg-black/0 cursor-pointer z-[1001] pointer-events-auto flex items-center justify-center text-white text-sm font-bold'
      onClick={handleClick}
    />
  )
}
